'use client'

import { useEffect } from 'react'
import { isDefined } from '@segway/core'
import useBraintreeDropin, {
  PaymentConfig,
} from '@segway/core/src/businessHooks/useBraintreeDropin'
import isEmpty from 'lodash/isEmpty'

import { useRouter } from '@/i18n/navigation'

type PaypalWidgetProps = {
  totalPrice: number
  productAdditionalData: string
  parsedPaymentConfig?: PaymentConfig
  pageType: 'pdp' | 'checkout'
}

const PaypalWidget = ({
  pageType,
  totalPrice,
  productAdditionalData,
  parsedPaymentConfig,
}: PaypalWidgetProps) => {
  const router = useRouter()

  const { braintreeInstance, handleApiAdditionalDataChange } = useBraintreeDropin(
    router,
    'braintree_paypal',
    totalPrice,
    productAdditionalData,
    pageType,
    parsedPaymentConfig,
  )

  useEffect(() => {
    if (isDefined(productAdditionalData) && !isEmpty(productAdditionalData)) {
      handleApiAdditionalDataChange(productAdditionalData)
    }
  }, [productAdditionalData, handleApiAdditionalDataChange])

  useEffect(() => {
    if (totalPrice && braintreeInstance) {
      braintreeInstance.updateConfiguration('paypal', 'amount', totalPrice?.toString())
    }
  }, [totalPrice, parsedPaymentConfig, braintreeInstance])

  useEffect(() => {
    const styleId = 'paypal-styles-' + Math.random().toString(36).substr(2, 9)
    const style = document.createElement('style')
    style.id = styleId
    style.textContent = `
      #braintree_paypal .braintree-dropin .braintree-placeholder {
        display: none !important;
      }

      #braintree_paypal .braintree-dropin .braintree-upper-container::before {
        border: none !important;
        background-color: transparent;
      }
      #braintree_paypal .braintree-dropin .braintree-upper-container .braintree-loader__container {
        display: none !important;
        border: none !important;
      }
      #braintree_paypal .braintree-dropin .braintree-upper-container .braintree-sheet__container .braintree-paypal {
        border: none !important;
      }
      #braintree_paypal .braintree-dropin .braintree-upper-container .braintree-sheet__container .braintree-paypal .braintree-sheet__header {
        display: none !important;
        width: 100% !important;
      }
      #braintree_paypal .braintree-dropin .braintree-upper-container .braintree-sheet__container .braintree-paypal .braintree-sheet__content {
        min-height: 100% !important;
        padding: 0 !important;
      }
      #braintree_paypal .braintree-dropin .braintree-upper-container .braintree-sheet__container .braintree-paypal .braintree-sheet__content .braintree-sheet__button--paypal {
        width: 100% !important;
      }
      #braintree_paypal .braintree-dropin .braintree-upper-container .braintree-sheet__container .braintree-paypal .braintree-sheet__content .braintree-sheet__button--paypal .paypal-button {
        width: 100% !important;
      }
      #braintree_paypal .braintree-dropin .braintree-upper-container .braintree-sheet__container .braintree-paypal .braintree-sheet__content .braintree-sheet__button--paypal .paypal-button .zoid-outlet {
        width: 100% !important;
      }
      #braintree_paypal .braintree-method--active {
        margin: 0;
      }
    `
    document.head.appendChild(style)

    return () => {
      const styleElement = document.getElementById(styleId)
      if (styleElement) document.head.removeChild(styleElement)
    }
  }, [])

  return <div id="braintree_paypal" />
}

export default PaypalWidget
